/* eslint-disable lines-between-class-members */
/* eslint-disable import/prefer-default-export */
export class MisDatosConstants {
  // flag numerico
  static FLAG_NUMBER_NO_ACTIVO = 0 as number;
  static FLAG_NUMBER_ACTIVO = 1 as number;

  // tipos usuario
  static ID_TIPO_USUARIO_PARTICULAR = 1 as number;
  static ID_TIPO_USUARIO_EMPRESA = 2 as number;
  static ID_TIPO_USUARIO_GIBRALTAR = 3 as number;
  static ID_TIPO_USUARIO_ANDORRA = 4 as number;

  // respuesta del servicio de update de datos personales
  static UPDATE_PERSONALES_OK_ACTIVAR_SMS = 1 as number;

  // tipos direccion
  static ID_TIPO_HABITUAL = 0 as number;
  static ID_TIPO_ENTREGA = 1 as number;
  static ID_TIPO_FACTURACION = 2 as number;

  // tipos de documento
  static TIPO_DOC_DNI = 1 as number;
  static TIPO_DOC_PASAPORTE = 2 as number;
  static TIPO_DOC_NIE_TARJETA_RESIDENCIA = 3 as number;
  static TIPO_DOC_CIF = 4 as number;
  static TIPO_DOC_OTROS = 5 as number;

  // tipos de actualización
  static TIPO_PARTICULAR_UPDATE = 'particular' as string;
  static TIPO_EMPRESA_UPDATE = 'empresa' as string;

  // tipos de documento Kosmos
  static TIPO_DOC_DNI_KOSMOS = 'N' as string;
  static TIPO_DOC_PASAPORTE_KOSMOS = 'P' as string;
  static TIPO_DOC_NIE_TARJETA_RESIDENCIA_KOSMOS = 'E' as string;
  static TIPO_DOC_CIF_KOSMOS = 'C' as string;
  static TIPO_DOC_TARJETA_RESIDENCIAL_KOSMOS = 'T' as string;
  static TIPO_DOC_CARTA_DE_TRABAJO_KOSMOS = 'R' as string;

  static TAMANIO_MAX_PASAPORTE = 20 as number;

  // valores idiomas
  static ID_ESPANIOL = 'C' as string;
  static ID_CATALAN = 'T' as string;
  static ID_EUSKERA = 'E' as string;
  static ID_GALLEGO = 'GAL' as string;
  static ID_INGLES = 'I' as string;
  static ID_ALEMAN = 'A' as string;
  static TODOS_IDIOMAS_EROSKI: string[] = [
    MisDatosConstants.ID_ESPANIOL,
    MisDatosConstants.ID_CATALAN,
    MisDatosConstants.ID_EUSKERA,
    MisDatosConstants.ID_GALLEGO,
    MisDatosConstants.ID_INGLES,
    MisDatosConstants.ID_ALEMAN,
  ];
  static TODOS_IDIOMAS_CAPRABO: string[] = [
    MisDatosConstants.ID_ESPANIOL,
    MisDatosConstants.ID_CATALAN,
  ];

  // tipos de geolocalizacion
  static GEOLOCALIZACION_COD_POSTAL = 'CP' as string; // Codigo postal.
  static GEOLOCALIZACION_NOMBRE_VIA = 'NV' as string; // Nombre de via.
  static GEOLOCALIZACION_NV_SIN_CP = 'NC' as string; // NC. Nombre de via, sin contraste de código postal.
  static GEOLOCALIZACION_NV_SIN_LOCALIDAD = 'NL' as string; // NL. Nombre de via, sin contraste de localidad.
  static GEOLOCALIZACION_NV_SIN_CP_Y_SIN_LOCALIDAD = 'NS' as string; // NS. Nombre de via, sin contraste de código postal y localidad.

  // pantallas desde la que la localida se ha introducido manualmente
  static LOCALIDAD_DESDE_MIS_DATOS = 'MDL' as string;
  static LOCALIDAD_DESDE_REGISTRO = 'F2L' as string;
  static LOCALIDAD_DESDE_FORMULARIO_REUTILIZABLE = 'FDRL' as string;

  // Preferencia vales-ahorro/cupones
  static EROSKI_PROMOCION_CAJA = 'EC' as string;
  static EROSKI_PROMOCION_DIGITAL = 'ED' as string;
  static CLIENTE_PROMOCION_CAJA = 'CC' as string;
  static CLIENTE_PROMOCION_DIGITAL = 'CD' as string;
  // ORIGENES PREFERENCIA
  static ORIGEN_ACTIVAR_CUPON = 'V_AC' as string;
  static ORIGEN_MODIFICACION_PREFERENCIA = 'Mis datos – Modificacion' as string;

  // tipos distintos en la respuesta de la geolocalizacion
  static GL_TYPE_CODIGO_POSTAL = 'postal_code' as string;
  static GL_TYPE_NOMBRE_VIA = 'route' as string;
  static GL_TYPE_NUMERO = 'street_number' as string;
  static GL_TYPE_LOCALIDAD = 'locality' as string;
  static GL_TYPE_COMUNIDAD_AUTONOMA = 'administrative_area_level_1' as string;
  static GL_TYPE_PAIS = 'country' as string;
  static GL_TYPES_FOR_SHORT_VALUE: string[] = [
    MisDatosConstants.GL_TYPE_CODIGO_POSTAL,
    MisDatosConstants.GL_TYPE_NUMERO,
    MisDatosConstants.GL_TYPE_COMUNIDAD_AUTONOMA,
  ];

  // genero
  static HOMBRE = 'H' as string;
  static MUJER = 'M' as string;

  // prefijos
  static PREFIJO_ESPANIA = '34' as string;
  static PREFIJO_GIBRALTAR = '350' as string;
  static PREFIJO_ANDORRA = '376' as string;
  static PREFIJO_INGLATERRA = '44' as string;
  static ID_PREFIJO_ESPANIA = 1 as number;
  static ID_PREFIJO_GIBRALTAR = 2 as number;
  static ID_PREFIJO_ANDORRA = 3 as number;
  static ID_PREFIJO_INGLATERRA = 6 as number;

  static CODIGO_POSTAL_GIBRALTAR = 'GX11 1AA' as string;

  // tipos socio desde back
  static TIPO_SOCIO_NINGUNO = 0 as number;
  static TIPO_SOCIO_EROSKI_CLUB = 1 as number;
  static TIPO_SOCIO_CONSUMIDOR = 2 as number;
  static TIPO_SOCIO_AMBOS = 3 as number;
  static TIPO_SOCIO_CONSUMIDOR_ANTIGUO = 4 as number;
  static TIPO_SOCIO_AMBOS_ANTIGUO = 5 as number;

  // tamaño maximo de campos
  static MAX_LENGTH_LOCALIDAD = 40 as number;
  // tamanios maximo de los campos
  static MAX_LENGTH_NOMBRE = 35 as number;
  static MAX_LENGTH_RAZON_SOCIAL = 35 as number;
  static MAX_LENGTH_APELLIDO_1 = 35 as number;
  static MAX_LENGTH_CARNE = 12 as number;
  static MAX_LENGTH_APELLIDO_2 = 35 as number;
  static MAX_LENGTH_DOCUMENTO = 11 as number;
  static MAX_LENGTH_EMAIL = 75 as number;
  static MAX_LENGTH_CODIGO_POSTAL = 8 as number;
  static MAX_LENGTH_NOMBRE_DE_VIA = 40 as number;
  static MAX_LENGTH_NOMBRE_DE_VIA_GIBRALTAR = 80 as number;
  static MAX_LENGTH_NUMERO = 4 as number;
  static MAX_LENGTH_PORTAL = 3 as number;
  static MAX_LENGTH_ESCALERA = 2 as number;
  static MAX_LENGTH_PISO = 2 as number;
  static MAX_LENGTH_PUERTA = 2 as number;
  static MAX_LENGTH_DIR_FAC_DOC = 11 as number;
  static MAX_LENGTH_DIR_FAC_CIF = 9 as number;
  static MAX_LENGTH_NOMBRE_DIRECCION = 50 as number;
  static MAX_LENGTH_PASSWORD = 255 as number;

  static MAX_LENGTH_COD_POSTAL_DIR_FAC = 5 as number;
  static MAX_LENGTH_LOCALIDAD_DIR_FAC = 50 as number;
  static MAX_LENGTH_PROVINCIA_DIR_FAC = 50 as number;
  static MAX_LENGTH_RAZON_SOCIAL_DIR_FAC = 40 as number;

  // tamanios minimo de los campos
  static MIN_LENGTH_PASSWORD = 8 as number;
}
